/**
 * The app chrome pinned to the top of the window: the topbar (`h-14`) and,
 * above it, while a super admin is viewing the app as someone, the "Viewing
 * as" bar (`ImpersonationBanner`, `h-8`). Every surface that pins under the
 * chrome sits below both: `top-chrome` in a class, `topChromeOffset()` where
 * the offset is pixels in JS.
 *
 * A view-as session starts and ends with a full page load, so whether the
 * bar shows is fixed for the life of the page. `AppShell` sets it once, from
 * the session, before anything below it renders.
 */

/** The topbar's height (`h-14`). */
export const TOPBAR_HEIGHT_PX = 56;

/** The "Viewing as" bar's height (`h-8`). */
export const VIEWING_AS_BAR_HEIGHT_PX = 32;

let viewingAsBar = false;

/** Shows or hides the "Viewing as" bar's room at the top of the app: the
 *  `--viewing-as-bar-height` CSS variable and `topChromeOffset()`. */
export function setViewingAsBar(on: boolean): void {
  if (on === viewingAsBar) return;
  viewingAsBar = on;
  document.documentElement.style.setProperty(
    "--viewing-as-bar-height",
    on ? `${VIEWING_AS_BAR_HEIGHT_PX}px` : "0px",
  );
}

/** Pixels from the window's top to the bottom of the app chrome: where a
 *  surface pinned under the topbar sits. */
export function topChromeOffset(): number {
  return TOPBAR_HEIGHT_PX + (viewingAsBar ? VIEWING_AS_BAR_HEIGHT_PX : 0);
}
